import { getSpaceBlogPosts } from '@/lib/content';
import PageMeta from '@/shared/components/PageMeta';
import { useLanguage } from '@/shared/contexts/LanguageContext';
import { formatDate, getText } from '@/shared/utils/i18n';
import { Calendar } from 'lucide-react';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';

export default function BlogPage() {
  const { language, t } = useLanguage();
  const posts = useMemo(() => getSpaceBlogPosts(language), [language]);

  return (
    <div className="pt-24 px-6">
      <PageMeta title="Blog" description={getText('blogTagline', 'en')} path="/space/blog" />
      <div className="max-w-3xl mx-auto space-y-12">
        <header>
          <h1 className="text-4xl font-bold mb-3">{t('spaceBlog')}</h1>
          <p className="text-lg text-muted-foreground">{t('blogTagline')}</p>
        </header>

        <div className="space-y-8">
          {posts.length === 0 && <p className="text-muted-foreground">{t('noPosts')}</p>}
          {posts.map(post => (
            <article key={post.slug} className="group">
              <Link to={`/space/blog/${post.slug}`} className="block space-y-2">
                <h2 className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
                  {post.meta.title}
                </h2>
                <div className="flex items-center gap-3 text-sm text-muted-foreground">
                  <span className="inline-flex items-center gap-1.5">
                    <Calendar className="w-3.5 h-3.5" />
                    {formatDate(post.meta.date, language)}
                  </span>
                  {post.meta.category && <span>{post.meta.category}</span>}
                </div>
                <p className="text-muted-foreground leading-relaxed">{post.meta.summary}</p>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
